// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/descuentos/descuentos.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_DESCUENTOS = [
  {
    id: 'id',
    label: 'ID',
    width: 80,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Descuento',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'descuento',
    label: 'Descuento',
    width: 300,
    sortable: true,
    filter: 'text',
    group: 'Descuento',
  },
  {
    id: 'porcentaje',
    label: 'Porcentaje',
    width: 120,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Descuento',
  },
  {
    id: 'fecha_inicio',
    label: 'Fecha inicio',
    width: 130,
    sortable: true,
    filter: 'date',
    group: 'Descuento',
  },
  {
    id: 'fecha_fin',
    label: 'Fecha fin',
    width: 130,
    sortable: true,
    filter: 'date',
    group: 'Descuento',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_DESCUENTOS = 'descuentos';
